import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <AboutSection />
        <CommentsSection />
        <TopicsSection />
        <ContactSection />
        <IndexSection />
        <FeaturesSection />
        <MediaSection />
        <CardsSection />
        <CarouselSection />
        <UpdatesSection />
        <AppSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}